






























































import {Component, Mixins} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import {$, PageCollection, pushByName} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {MixinSelect} from '@/components/mixins/MixinSelect'
import {AppConfig} from '@/config/app.config'
import Responsavel from '@/model/resource/Responsavel'
import {snakeCase} from 'lodash'
import * as Helper from '@/helpers'
import AuditValidation from '../../model/resource/AuditValidation'
import ModalAudit from '@/components/modals/ModalAudit.vue'

const metaInfo = () => ({
    title: $.t('classes.AuditValidation.title'),
})

@Component({
    metaInfo,
    components: {
        ModalAudit,
    },
})
export default class ManageAwaitingAuditValidationListView extends Mixins(MixinFilter, MixinSelect) {
    @Getter('auth/responsavel') user!: Responsavel
    @Action('refreshView') refreshView!: Function

    AppConfig = AppConfig
    pushByName = pushByName

    collection = new PageCollection(AuditValidation, {}, 10)

    openModalAudit(id: number) {
        this.$modal.open('modalAudit', id)
    }

    async downloadData(xlsx = false) {
        if (!xlsx) {
            const csv = new PageCollection(AuditValidation, {}, null, null)

            const fetch = async () => await csv.search()
            await $.await.run(fetch, 'download')
            csv.downloadCsv(snakeCase($.t('classes.AuditValidation.title')))
        } else {
            await $.await.run(() => Helper.downloadXlsx(
                $.t('classes.AuditValidation.title'),
                new AuditValidation().$endpoint,
                this.filter,
                AuditValidation,
                'AuditValidation',
            ), 'download')
        }
    }

    refresh() {
        this.refreshView()
    }
}
